import Alert from '@storeblocks/alert';
import { Icon } from '@storeblocks/icon';
import styled from 'styled-components';

import { getMaxScreenWidths } from 'Utils/screenSizes.utils';

export const InsuranceDetailsContainer = styled.div`
  width: 70%;
  max-width: 712px;

  ${getMaxScreenWidths.tablet} {
    width: 100%;
  }
`;

export const DetailedInsuranceTitleContainer = styled.div`
  width: 100%;
  margin: 0 0 24px;
  display: flex;
  align-content: flex-start;
`;

export const AlertFullWidth = styled(Alert)`
  width: 100%;
  max-width: 100%;
  margin: 0 auto 24px;
`;

export const InsuranceViewContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 712px;
  height: auto;
  padding: 32px 48px 24px;
  background-color: var(--p-color-surface-1);

  & > * {
    margin: 10px 0;
  }

  ${getMaxScreenWidths.mobileL} {
    padding: 12px 8px;
  }
`;

export const ButtonWrapper = styled.div`
  margin-top: 20px;
  ${getMaxScreenWidths.mobileL} {
    display: flex;
    flex-direction: column;
    gap: 20px;

    a {
      margin-right: 0 !important;
    }
  }
`;

export const CardTitle = styled.h2`
  margin: 5px 0;
  text-align: center;
  font-weight: bold;
`;

export const StyledIcon = styled(Icon)`
  height: 100px;
  width: 100px;
  padding: 0px;

  svg {
    width: 102.78px;
    height: 102.78px;
  }
`;

export const ContentWrapper = styled.div`
  width: inherit;
`;

export const MobileContentWrapper = styled.div`
  width: inherit;
  ${getMaxScreenWidths.mobileL} {
    padding-left: 16px;
  }
`;

export const DocumentsWrapper = styled.div`
  align-self: flex-start;
  margin-top: 16px;
`;
